import React, { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { HOST } from "../../common/constant";
import axiosInstance from "../../common/interceptor";
import { toastOptions } from "../../common/Utils";
import "./AsphaltDashboard.css";

/**
 * 積載量編集（SKY-51）: メイン表の積載量(t)セルのクリックで遷移し、対象の1台目のみを編集する。
 * URL クエリ ?id=<トリップID> で対象を特定。
 */
interface IRow {
  id: number;
  terminalName?: string;
  daiMe?: number | null;
  state?: string;
  loadTon?: number | null;
}

const LoadEdit: React.FC = () => {
  const id = new URLSearchParams(window.location.search).get("id");
  const [row, setRow] = useState<IRow | null>(null);
  const [loadTon, setLoadTon] = useState<string>("");

  const load = useCallback(() => {
    axiosInstance
      .get(HOST() + "/Form/V1/Dat/AsphaltDashboard/Board")
      .then((res) => {
        const rows = (res.data?.data?.rows as IRow[]) ?? [];
        const r = rows.find((x) => String(x.id) === String(id)) ?? null;
        setRow(r);
        setLoadTon(r?.loadTon !== null && r?.loadTon !== undefined ? String(r.loadTon) : "");
      })
      .catch(() => toast.error("データの取得に失敗しました。", toastOptions));
  }, [id]);

  useEffect(() => {
    load();
  }, [load]);

  const back = () => (window.location.href = "/dashboard");

  const save = () => {
    if (!row) return;
    // 積載量(t)は 0 以上・小数第二位。負値/不正は 0 に丸め、2桁で送信(DBと表示を一致)。
    const n = loadTon === "" ? 0 : Number(loadTon);
    const val = isNaN(n) || n < 0 ? 0 : Math.round(n * 100) / 100;
    axiosInstance
      .put(HOST() + "/Form/V1/Dat/AsphaltDashboard/Load", { id: row.id, loadTon: val })
      .then(() => {
        toast.success("更新に成功。", toastOptions);
        back();
      })
      .catch(() => toast.error("更新に失敗。", toastOptions));
  };

  return (
    <div className="asp-dashboard">
      <div style={{ maxWidth: "460px", margin: "0 auto" }}>
        <div className="asp-devhead">
          <div className="asp-title" style={{ flex: 1 }}>積載量編集</div>
          <div>
            <button type="button" className="btn btn-primary btn-sm mar-5" onClick={back}>キャンセル</button>
            <button type="button" className="btn btn-primary btn-sm mar-5" onClick={save}>保存</button>
          </div>
        </div>

        {row === null ? (
          <div className="asp-empty" style={{ padding: "20px 4px" }}>対象データがありません。</div>
        ) : (
          <div className="asp-loadedit">
            <div className="asp-loadedit-row">
              <span className="asp-loadedit-label">台目</span>
              <span className="asp-loadedit-sep">：</span>
              <span className="asp-loadedit-val">{row.daiMe ?? ""}</span>
            </div>
            <div className="asp-loadedit-row">
              <span className="asp-loadedit-label">端末名</span>
              <span className="asp-loadedit-sep">：</span>
              <span className="asp-loadedit-val">{row.terminalName}</span>
            </div>
            <div className="asp-loadedit-row">
              <span className="asp-loadedit-label">積載量(t)</span>
              <span className="asp-loadedit-sep">：</span>
              <input
                type="number"
                step="0.01"
                min="0"
                className="form-control"
                style={{ width: "160px", display: "inline-block" }}
                value={loadTon}
                onChange={(e) => setLoadTon(e.target.value)}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadEdit;
